module.exports = __webpack_public_path__ + "805c2c796b8b98e8a58d3ed7049b6379.svg";